import React from 'react';
import { useTranslations } from 'next-intl';

interface IProps {
  followers?: number;
  students?: number;
}

const Followers: React.FC<IProps> = ({ followers, students }) => {
  const t = useTranslations();

  return (
    <div className="mt-3 grid grid-cols-2 items-center rounded-lg bg-gray-50 py-1">
      <div className="flex flex-col border-r border-gray-300 pl-2">
        <span className="font-medium text-gray-900">{students}</span>
        <span className="text-xs text-gray-400">{t('oquvchilar')}</span>
      </div>
      <div className="flex flex-col pl-3">
        <span className="font-medium text-gray-900">{followers}</span>
        <span className="text-xs text-gray-400">{t('profile.left_side.obunachilar')}</span>
      </div>
    </div>
  );
};

export default Followers;
